import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { BLOCKED_PAYMENT_STATUSES } from './blocked-payment-statuses.js';
/** Spec M-1/N27: recording a payment or clearing the balance stops after Delivered, while a reversal stays allowed at Complete (N17). */
export const PAYMENT_WRITE_BLOCKED_STATUSES = [
    ...BLOCKED_PAYMENT_STATUSES,
    SalesOrderStatus.COMPLETE,
];
//# sourceMappingURL=payment-write-blocked-statuses.js.map